<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  <environment-selector [hasFlags]="false"></environment-selector>
  Password Manager MellowoodMedical<br />
  ({{ "webVault" | i18n }})
  {{ "versionNumber" | i18n : version }}
</div>
